module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4HwLzQnYGkM6c0Y4egCkos-a479ee106995cbc398966e549eda848f.jpg";